import React from 'react'

const Load = () => {
    return (
        <div className='Load'>
            <i className="xi-spinner-1 xi-spin"></i>
        </div>
    )
}

export default Load